import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { sendVerificationEmail, signOut } from '../../store/actions/authActions';
import { Redirect } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

const VerifyEmailButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;

const SignOutButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.backgroundColor};
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.backgroundColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            color: ${(props) => props.themeColors.backgroundColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;

const containerStyle = {
    marginTop: '10%',
    marginBottom: '10%',
    width: '500px',
};

const VerifyEmailPage = (props) => {
    if (props.isSignedIn && props.isEmailVerified) {
        return (
            <div className="container" style={{ marginTop: '10%' }}>
                <h3>You are already verified!</h3>
            </div>
        )
    } else if (props.isSignedIn && !props.isEmailVerified) {
        return (
            <div className="container" style={containerStyle}>
                <h3><b>Hi</b>, <i>{props.userAuth.email}</i></h3>
                <p style={{ color: props.themeColors.darkThemeColor }}>
                    <b>
                        We have sent you a verification email, please verify and reload or press sign in.
                    </b>
                </p>
                <br></br>
                <div className="btn-group" role="group" aria-label="Basic example">
                    <VerifyEmailButton themeColors={props.themeColors}>
                        <button className="btn btn-default" onClick={() => props.sendVerificationEmail()}>
                            Send verification email again?
                        </button>
                    </VerifyEmailButton>
                    <SignOutButton themeColors={props.themeColors}>
                        <button className="btn btn-default" onClick={() => props.signOut()}>Sign in</button>
                    </SignOutButton>
                </div>
                <p>{props.auth.message}</p>
            </div>
        )
    } else {
        return <Redirect to={ROUTES.LANDING} />;
    }
}

const mapStateToProps = (state) => {
    // console.log(state)
    return {
        themeColors: state.theme,
        isSignedIn: !state.firebase.auth.isEmpty,
        isEmailVerified: state.firebase.auth.emailVerified,
        userAuth: state.firebase.auth,
        auth: state.auth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        sendVerificationEmail: () => dispatch(sendVerificationEmail()),
        signOut: () => dispatch(signOut()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailPage);
